import React from 'react';
import { motion } from 'motion/react';

import { useGetParams } from '../../hooks/useGetParams';
import styles from './AdvtFullSize.module.css';

import logo from '../../assets/images/logo.png';
import delo from '../../assets/images/delo.png';
import ncsp from '../../assets/images/ncsp.png';
import questions from '../../assets/images/questions.webp';

import advtBg from '../../assets/video/advtBg.webm';
import advtBgPoster from '../../assets/images/advtBgPoster.webp';

const AdvtFullSize = React.memo(() => {
  const { paddingQR, sizeQR, titleFontSize, qrCode1, qrCode2, title } =
    useGetParams();

  const advtlines = title.split(/\\n/);
  const initDelay = 0.4;

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="logo" className={styles.logo} />
      <img src={delo} alt="delo" className={styles.delo} />
      <img src={ncsp} alt="ncsp" className={styles.ncsp} />

      <motion.img
        initial={{ scale: 1, opacity: 0.13 }}
        animate={{ scale: 11, opacity: 0 }}
        transition={{
          scale: { duration: 1.5, delay: initDelay },
          opacity: { duration: 0.3, delay: initDelay + 1.5 },
        }}
        src={questions}
        alt="questions"
        className={styles.questions}
      />

      {advtlines && (
        <motion.div
          className={styles.title}
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          transition={{
            duration: 0.6,
            delay: initDelay + 4,
          }}
        >
          {advtlines[0] && (
            <motion.div
              className={styles.titleLine1}
              initial={{ scale: 0 }}
              animate={{ scale: [0, 1.15, 1] }}
              transition={{
                times: [0, 0.8, 1],
                duration: 1.36,
                delay: initDelay,
                ease: 'easeOut',
              }}
            >
              {advtlines[0]}
            </motion.div>
          )}
          {advtlines[1] && (
            <motion.div
              className={styles.titleLine2Block}
              initial={{ backgroundColor: 'rgba(255, 87, 186, 0)' }}
              animate={{ backgroundColor: 'rgba(255, 87, 186, 1)' }}
              transition={{
                duration: 0.52,
                delay: initDelay + 2.32,
              }}
            >
              <motion.div
                className={styles.titleLine2}
                initial={{
                  y: '-100%',
                  opacity: 0,
                }}
                animate={{
                  y: 0,
                  opacity: 1,
                }}
                transition={{
                  duration: 1,
                  delay: initDelay + 1.36,
                }}
              >
                {advtlines[1]}
              </motion.div>
            </motion.div>
          )}
        </motion.div>
      )}

      <div className={styles.qrBlock}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: initDelay + 4.72,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode1} alt="qrCode1" />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.1, 1] }}
            transition={{
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: initDelay + 5.28,
              },
            }}
            className={styles.qrCode}
            style={{
              width: `${sizeQR}rem`,
              height: `${sizeQR}rem`,
              padding: `${paddingQR}rem`,
            }}
          >
            <img src={qrCode2} alt="qrCode1" />
          </motion.div>
        )}
      </div>

      <video
        playsInline
        autoPlay="autoplay"
        muted="muted"
        loop
        id="bgVideo"
        poster={advtBgPoster}
      >
        <source src={advtBg} type="video/webm" />
      </video>
    </div>
  );
});

export default AdvtFullSize;
